var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "mt-5" },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12", md: "8", lg: "6" } },
            [
              _vm.showTable
                ? _c(
                    "b-button",
                    {
                      staticClass: "mb-3",
                      attrs: { variant: "primary", block: "" },
                      on: { click: _vm.back },
                    },
                    [_vm._v(" Back ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "justify-content-center" },
        [
          !_vm.showTable
            ? _c(
                "b-col",
                { attrs: { cols: "12", md: "8", lg: "6" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "shadow",
                      attrs: {
                        header: "Select Date Range",
                        "header-tag": "h4",
                      },
                    },
                    [
                      _c(
                        "b-form",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Date From",
                                "label-for": "date-from",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                attrs: {
                                  id: "date-from",
                                  placeholder: "Select start date",
                                  max: _vm.dateTo,
                                },
                                model: {
                                  value: _vm.dateFrom,
                                  callback: function ($$v) {
                                    _vm.dateFrom = $$v
                                  },
                                  expression: "dateFrom",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Date To",
                                "label-for": "date-to",
                              },
                            },
                            [
                              _c("b-form-datepicker", {
                                attrs: {
                                  id: "date-to",
                                  placeholder: "Select end date",
                                  min: _vm.dateFrom,
                                },
                                model: {
                                  value: _vm.dateTo,
                                  callback: function ($$v) {
                                    _vm.dateTo = $$v
                                  },
                                  expression: "dateTo",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3",
                              attrs: { variant: "primary", block: "" },
                              on: { click: _vm.submitDates },
                            },
                            [_vm._v(" Submit ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showTable
            ? _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    {
                      staticClass: "shadow",
                      attrs: { header: _vm.tdsHeader, "header-tag": "h4" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mb-3",
                          attrs: { variant: "success" },
                          on: { click: _vm.exportToCSV },
                        },
                        [_vm._v(" Export to CSV ")]
                      ),
                      _c("b-table", {
                        attrs: {
                          striped: "",
                          hover: "",
                          responsive: "sm",
                          items: _vm.paginatedItems,
                          fields: _vm.tableFields,
                          "sort-by": _vm.sortBy,
                          "sort-desc": _vm.sortDesc,
                        },
                        on: {
                          "update:sortBy": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sort-by": function ($event) {
                            _vm.sortBy = $event
                          },
                          "update:sortDesc": function ($event) {
                            _vm.sortDesc = $event
                          },
                          "update:sort-desc": function ($event) {
                            _vm.sortDesc = $event
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "cell(link)",
                              fn: function (data) {
                                return [
                                  _c("feather-icon", {
                                    staticClass: "mr-50",
                                    attrs: { icon: "EyeIcon", size: "16" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.viewContent(data.item)
                                      },
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1277299302
                        ),
                      }),
                      _c("b-pagination", {
                        staticClass: "mt-3 justify-content-center",
                        attrs: {
                          "total-rows": _vm.tableData.length,
                          "per-page": _vm.perPage,
                          "aria-controls": "cashbook-table",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }